import { render } from "./TeamPanel.vue?vue&type=template&id=2c319ea7&scoped=true"
import script from "./TeamPanel.vue?vue&type=script&lang=js"
export * from "./TeamPanel.vue?vue&type=script&lang=js"

import "./TeamPanel.vue?vue&type=style&index=0&id=2c319ea7&lang=less&scoped=true"

import exportComponent from "/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2c319ea7"]])

export default __exports__